<div class="master-modal account_request_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">Rating and review </h4>
        <div class="modal_close_btn">
          <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
    <form [formGroup]="ratingReviewForm" (ngSubmit)="sendRatingAndReview()" class="form-section address-form-section">
      <!-- Modal content-->
      <perfect-scrollbar class="modal-body-scrollbar">
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body">
            <!-- Phone No -->
            <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
            fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
            <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              fxFlexFill>
               <!-- mobile -->
               <div class="custom-form-group">
                <label class="custom-label fx-display" for="">Your rating<span class="star">*</span> </label>
                <div class="custom-form-control">
                  <div class="slot-selection">
                    <mat-button-toggle-group formControlName="rating" class="selection-list">
                      <mat-button-toggle value="1"> 1 <i class="material-icons">
                          grade
                        </i></mat-button-toggle>
                      <mat-button-toggle value="2"> 2 <i class="material-icons">
                          grade
                        </i> </mat-button-toggle>
                      <mat-button-toggle value="3"> 3 <i class="material-icons">
                          grade
                        </i> </mat-button-toggle>
                      <mat-button-toggle value="4"> 4 <i class="material-icons">
                          grade
                        </i> </mat-button-toggle>
                      <mat-button-toggle value="5"> 5 <i class="material-icons">
                          grade
                        </i> </mat-button-toggle>
                    </mat-button-toggle-group>
                    <mat-error *ngIf="rating.invalid && (rating.dirty || rating.touched)">
                      <span *ngIf="rating.hasError('required')"> Rating Required </span>
                    </mat-error>
                  </div>
                </div>
              </div>
              <!-- DESCRIPTION-TEXT-AREA-->
              <div class="custom-form-group">
                <label class="custom-label fx-display" for="">Add your review<span class="star">*</span> </label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline" class="w-100">
                    <textarea matInput formControlName="message" rows="3" cols="3"
                      placeholder="Enter review"></textarea>
                    <mat-error *ngIf="message.invalid && (message.dirty || message.touched)">
                      <span *ngIf="message.hasError('required')"> Review required </span>
                      <span *ngIf="message.hasError('maxlength')"> Maximum 1000 letters are allowed </span>
                    </mat-error>
                  </mat-form-field>
                  <mat-hint> {{(message?.value?.length ? message?.value?.length: 0)}}/1000</mat-hint>
                </div>
              </div>
              <div class="custom-form-group">
                <label class="custom-label" for=""> Attachments <span class="star">*</span></label>
                <div class="custom-form-control">
                  <app-file-upload [fileInput]="attachments" type="IMAGE"></app-file-upload>
                  <mat-error *ngIf="attachments.invalid && ( attachments.dirty || attachments.touched )">
                    <span>Please upload attachments </span>
                  </mat-error>
                </div>
              </div>
              </div>
          </div>
        </div>
        </div>
      </perfect-scrollbar>
      <!-- Modal-Footer -->
      <div class="modal-footer">
        <div mat-dialog-actions class="modal_footer">
          <button mat-button (click)="dialogClose('no')" class="modal-cancel-btn modal-footer-btn">
            <span>Cancel</span>
          </button>
          <button mat-button class="modal-save-btn global-btn modal-footer-btn">
            <span>Save</span>
          </button>
        </div>
      </div>
    </form>
    </div>
  </div>
</div>
